<template>
  <v-app>
    <v-main>
      <su-success-alert/>
      <su-error-alert/>
      <router-view/>
    </v-main>
  </v-app>
</template>

<script>

import SuSuccessAlert from "@/components/SuccessAlert.vue";
import SuErrorAlert from "@/components/ErrorAlert.vue";

export default {
  name: 'App',
  components: {SuErrorAlert, SuSuccessAlert},
}
</script>

<style>
</style>
